export { default as useRenewalCardTranslation } from './useRenewalCardTranslation';
